import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrending2"><Path d="M2.5 10.9375L4.61111 14.125L7.77778 8.8125L13.0556 20.5L18.3333 3.5L21.5 9.875" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTrending2;
